<template>
  <div class="category-wrap">
    <Breadcrumb :config="{items: navItems}" />
    <div class="list">
      <div class="layout">
        <div class="ms-row category-kv" v-if="category">
          <template v-if="category.cat_kv_image">
            <div class="good-pic col-xs-12 col-sm-7 col-md-7">
              <img class="lazyloaded" :src="category.cat_kv_image + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="category.cat_name" />
            </div>
            <div class="good-txt text--left col-xs-12 col-sm-5 col-md-5">
              <div class="result-count heading-h3">
                <span class>{{category.product_num}}</span> 个产品
              </div>
              <h1 :class="['banner-title', !isMaster ? 'title-with-background' : '']">{{category.cat_name}}</h1>
              <div class="banner-link"><p style="color: #000;">{{category.cat_desc}}</p></div>
            </div>
          </template>
          <template v-else>
            <div class="category__content col-xs-12 col-sm-12">
              <div class="result-count heading-h3">
                <span class>{{category.product_num}}</span> 个产品
              </div>
              <h1 :class="['banner-title', !isMaster ? 'title-with-background' : '']">{{category.cat_name}}</h1>
              <div class="banner-link"><p style="color: #000;">{{category.cat_desc}}</p></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <CategoryList v-if="id" :config="{category_id: id}" :info="category" :sort="true" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import CategoryList from '@/components/CategoryList.vue';
import types from '@/store/types';
import api from '@/utils/api';
import utils from '@/utils';

export default {
  name: "List",
  components: { Breadcrumb, CategoryList },
  data() {
    return {
      id: -1,
      category: null
    }
  },
  created() {
    let id = this.$route.params.id;
    this.initPage(id);
  },
  methods: {
    initPage(id) {
      id && (this.id = id) && this.loadSource();
    },
    loadSource() {
      api[types.CATEGORY_INFO]({ id: this.id }).then(res => {
        if (res.code == 1) {
          this.category = res.data;
          // 
          if (!this.category?.cat_name) return;
          //
          let title = this.category?.cat_name;
          if (this?.category?.cat_tree?.length) {
            let root = this.category.cat_tree[0].id;
            this.$store.commit('toggleNavType', root != 262);
            title = Array.from(this.category.cat_tree).reverse().map(item => item.cat_name).join(" - ");
          }
          utils.setPageInfo(`${title} - Sisley Paris`, {
            keywords: this.category.cat_name,
            description: this.category.cat_desc
          });
          // 
          this.report4Browser(this.id);
          // 
          this.gtmTrackCategory();
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 浏览上报
    report4Browser(id) {
      api[types.REPORT_BROWSER_PLP]({ cat_id: id}).then(res => {
        if (res.code != 1) {
          console.warn('[REPORT_BROWSER_PLP]: ', res);
        }
      });
    },
    // GTM
    gtmTrackCategory() {
      if (!window.dataLayer) return false;
      window.dataLayer.push({
        siteCountry: 'CN',
        siteLanguage: 'CN',
        pageCategory: this.isMaster ? 'Category' : 'Catalogue_Hair_Rituel'
      });
    }
  },
  computed: {
    // 面包屑
    navItems() {
      let ret = [];
      if (this.category?.cat_tree?.length) {
        ret = ret.concat(this.category?.cat_tree?.map(item => {
          return { href: `/category/${item.id}`, text: item.cat_name };
        }));
      }
      return ret;
    },
    isMaster() {
      return this.$store.state.isMaster;
    }
  },
  watch: {
    $route(to) {
      let id = to.params.id;
      this.initPage(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.list { margin: 10px 0 20px; padding: 0 17px; }
.category-kv { position: relative; }
.good-pic {
  margin-bottom: 30px;
  img { width: 100%; height: auto; }
}
.good-txt {
  width: 100%;
  .heading-h3 { font-size: 12px; font-weight: 400; }
  .banner-title {
    font-size: 1.5625rem; font-weight: 400; font-style: normal;
  }
  .banner-link { margin-top: .625rem; }
}
.banner-title.title-with-background {
  box-decoration-break: clone;
  display: inline;
  padding: 0 .625rem;
  background-repeat: no-repeat;
  background-image: linear-gradient(0deg,#ffe800,#ffe800);
  background-size: 100% 13px;
  background-position: 0 1rem;
}

@media screen and (min-width: 48em) {
  .ms-row {
    .good-pic { margin-bottom: 0; }
    .good-txt { display: flex; flex-direction: column; justify-content: center; padding: 0 3.9375rem 0 2.8125rem; }
    // .good-txt { position: absolute; top: 50%; right: 0; transform: translateY(-50%) translateY(-.5px); padding: 0 3.9375rem 0 2.8125rem; }
  }
  .banner-title.title-with-background {
    background-size: 100% 18px;
    background-position: 0 1.375rem;
  }
}

@media screen and (min-width: 64em) {
  .category-wrap /deep/ .breadcrumb { padding: 0 1.875rem; }
  .ms-row {
    .good-txt {
      padding: 0 2.0625rem 0 3.5625rem;
      .banner-title { font-size: 2.1875rem; }
    }
  }
  .banner-title.title-with-background {
    background-size: 100% 27px;
    background-position: 0 2rem;
  }
}

@media screen and (min-width: 75em) {
  .ms-row {
    .good-txt {
      padding: 0 5.1875rem 0 6.6875rem;
      .banner-title { font-size: 3.125rem; margin-bottom: .9375rem; }
      .banner-link { margin-top: .9375rem; }
    }
  }
}
</style>